import { Injectable, inject } from '@angular/core';

import { environment } from '../../environments/environment';
import { AuthService } from '../../modules/auth/auth.service';
import { DashboardService } from './dashboard.service';
import { EquipmentService } from './equipment.service';
import { InventoryService } from './inventory.service';
import { MaintenanceService } from './maintenance.service';
import { SettingsService } from './settings.service';

/** Loads every available Gateway endpoint into the feature services. */
@Injectable({ providedIn: 'root' })
export class AppDataService {
  private readonly auth = inject(AuthService);
  private readonly dashboard = inject(DashboardService);
  private readonly inventory = inject(InventoryService);
  private readonly equipment = inject(EquipmentService);
  private readonly maintenance = inject(MaintenanceService);
  private readonly settings = inject(SettingsService);

  constructor() {
    // Settings lists are loaded via SettingsService.refreshFromApi().
  }

  refreshAll(): void {
    if (environment.useMockData || !this.auth.isAuthenticated()) {
      return;
    }

    this.dashboard.load();
    this.settings.refreshFromApi();
    this.inventory.refreshFromApi();
    this.inventory.refreshAssetsFromApi();
    this.equipment.refreshFromApi();
    this.equipment.refreshOverdueFromApi().subscribe({ error: () => undefined });
    this.maintenance.refreshFromApi();
  }
}
